import OspreyOffersGetById from './offers-get-by-id'
import OspreyOffersGetThumbnails from './offers-get-thumbnails'
import OsperyOffersMetadata from './offers-metadata'
import OspreyOffersSearch from './offers-search'
import OspreyOffersSearchSuggestion from './offers-search-suggestion'
import OspreyOffersTagsApply from './offers-tags-apply'
import OspreyOffersTagsRemove from './offers-tags-remove'
import OspreyOffersCreate from './offers-create'
import OspreyOffersShareToSilos from './offers-silos-share'
import OspreyOffersRemoveFromSilosShare from './offers-silos-remove'
import OspreyOffersShareToAffiliations from './offers-affiliations-share'
import OspreyOffersRemoveFromAffiliationsShare from './offers-affiliations-remove'
import OspreyOffersUpdate from './offers-update'
import OspreyOffersPropagate from './offers-propagate'
import OspreyOffersClone from './offers-clone'
import OspreyOffersUniqueName from './offers-unique-name'
import OspreyOffersDelete from './offers-delete'
import OspreyOffersBatchUpdate from './offers-batch-update'
import OspreyOffersImport from './offers-import'
import OspreyOffersImportStatus from './offers-import-status'

export default class Offers {

    create(dataKey) {
        return new OspreyOffersCreate(dataKey)
    }

    search(dataKey) {
        return new OspreyOffersSearch(dataKey)
    }

    getSearchSuggestion(dataKey) {
        return new OspreyOffersSearchSuggestion(dataKey)
    }

    getMetadata() {
        return new OsperyOffersMetadata()
    }

    getById(dataKey) {
        return new OspreyOffersGetById(dataKey)
    }

    getThumbnails(dataKey) {
        return new OspreyOffersGetThumbnails(dataKey)
    }

    applyTagToOffer(dataKey) {
        return new OspreyOffersTagsApply(dataKey)
    }

    removeTagFromOffer(dataKey) {
        return new OspreyOffersTagsRemove(dataKey)
    }

    shareToSilos(dataKey) {
        return new OspreyOffersShareToSilos(dataKey)
    }

    removeFromSilosShare(dataKey) {
        return new OspreyOffersRemoveFromSilosShare(dataKey)
    }

    shareToAffiliations(dataKey) {
        return new OspreyOffersShareToAffiliations(dataKey)
    }

    removeFromAffiliationsShare(dataKey) {
        return new OspreyOffersRemoveFromAffiliationsShare(dataKey)
    }

    update(dataKey) {
        return new OspreyOffersUpdate(dataKey)
    }

    propagate(dataKey) {
        return new OspreyOffersPropagate(dataKey)
    }

    clone(...args) {
        return new OspreyOffersClone(...args)
    }

    getOffersUniqueName(dataKey) {
        return new OspreyOffersUniqueName(dataKey)
    }

    deleteOffers(...args) {
        return new OspreyOffersDelete(...args)
    }

    batchUpdate(dataKey) {
        return new OspreyOffersBatchUpdate(dataKey)
    }

    getOfferImportCsvUploadUrl(dataKey) {
        return new OspreyOffersImport(dataKey)
    }

    initiateImport(dataKey) {
        return new OspreyOffersImport(dataKey)
    }

    getOfferImportStatus(dataKey) {
        return new OspreyOffersImportStatus(dataKey)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/index.js